import { useState } from "react";
import { ApiError } from "../../common/api/ApiClient";
import { useApiClient } from "../../common/hooks/useApiClient";
import { ProfileVersionSchema } from "../../common/models/schema/ProfileVersionSchema";

const basePath = "/nationbuilder/versions";

export const useProfileVersions = () => {
  const [personId, setPersonId] = useState("");
  const [versions, setVersions] = useState<ProfileVersionSchema[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [noVersions, setNoVersions] = useState(false);
  const apiClient = useApiClient();

  const handleSubmit = async () => {
    if (!personId.trim()) return;

    setLoading(true);
    setError(null);
    setNoVersions(false);
    try {
      setLoading(true);
      const response = await apiClient.get<{
        versions: ProfileVersionSchema[];
      }>(basePath + "/" + personId);
      const versions = response.data?.versions;
      setVersions(versions);
      setNoVersions(versions.length === 0);
    } catch (error) {
      const apiError = error as ApiError;
      setError(apiError.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setError(null);

    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setPersonId(value);
    }
  };

  const resetForm = () => {
    setPersonId("");
    setError(null);
  };

  const handleRollback = async () => {
    if (!personId.trim()) return;

    setLoading(true);
    setError(null);

    try {
      setLoading(true);
      await apiClient.put<any>(basePath + "/rollback-person-to-latest-manual", {
        person_id: personId,
      });
    } catch (error) {
      const apiError = error as ApiError;
      setError(apiError.message);
    } finally {
      setLoading(false);
    }
    await handleSubmit();
  };

  return {
    // State
    personId,
    versions,
    loading,
    error,
    noVersions,
    // Actions
    handleSubmit,
    handleRollback,
    handleInputChange,
    resetForm,
  };
};
